module.exports = __webpack_public_path__ + "media/images/diy/review_photo_one-dc0d2b48f3e0500dec73dcc9390b62cb.svg";